export default "__VITE_ASSET__By41MFCP__"